<template>
    <v-card id="timetable" elevation="4" class="mb-8">
        <v-toolbar color="cyan darken-4" dark flat dense>
            <v-toolbar-title>Your Timetable</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-scroll-to="'#top'" dark text>
                <v-icon left>fas fa-chevron-up</v-icon>
                Top
            </v-btn>
            <span v-scroll-to="'#kickers'" class="fa-stack fa-md icon-info">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-info fa-stack-1x"></i>
            </span>
        </v-toolbar>
        <v-card-text v-if="AreTimetablesAvailable">
            <h4>When will I know my timetable?</h4>
            <p>Timetables are available to view at the moment, although are subject to some changes.  We do hope this will be minimal.</p>
            <h4>Will I be required to attend an induction?</h4>
            <p>All courses will offer an induction.  Some of these may be a separate day before your start date, and for others it may be part of your first class.  We will email you confirmation of your induction arrangements 7 days prior to the induction date of your course.</p>
            <h4>I still have concerns about starting my studies</h4>
            <p>We understand that you may have some concerns or questions related to your studies.  Please be assured, we are here to support you.  Therefore, if you would like to discuss this matter further, do not hesitate to contact us by emailing <a href="mailto:heretohelp@dundeeandangus.ac.uk">heretohelp@dundeeandangus.ac.uk</a>.</p>
        </v-card-text>
        <v-card-text v-else>
            <h4>When will I know my timetable?</h4>
            <p>Your timetable for your full-time course starting in August is not yet available.  This will be available when you receive the Onboarding invitation email in July.</p>
        </v-card-text>
        <v-card-text v-if="ActiveEnrolments.length > 0">
            <v-card v-for="enrolment in ActiveEnrolments" :key="enrolment.enrolmentID" class="mb-4" outlined>
                <v-card-title>
                    <span class="body-1">{{ enrolment.CourseCode }} - {{ enrolment.CourseName }}</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="HasTimetableEvents(enrolment.CourseCode)" @click="OpenCourseTimetable(enrolment.CourseCode)" color="info" dark small style="color:white !important">
                        <v-icon left small>fas fa-calendar-alt</v-icon>
                        Check Your Timetable
                    </v-btn>
                    <v-btn v-else disabled small>
                        <v-icon left small>fas fa-calendar-alt</v-icon>
                        No Timetable
                    </v-btn>
                </v-card-title>
            </v-card>
        </v-card-text>
    </v-card>
</template>

<script>
    import moment from 'moment'

    import enrolmentsMixin from '@/views/components/mixins/enterpriseDataApi/enrolments.js'
    import timetableEventsMixin from '@/views/components/mixins/enterpriseDataApi/timetableEvents.js'

    export default {
        props: ['localSettings', 'enrolments'],
        mixins: [
            enrolmentsMixin,
            timetableEventsMixin,
        ],
        computed: {
            TimetablesAvailabilityDate() { return moment(this.localSettings?.keyValuePairs?.TimetablesAvailabilityDate); },
            AreTimetablesAvailable() { return moment() > this.TimetablesAvailabilityDate; },
        },
        mounted() {
            this.RefreshTimetableEvents();
        },
        methods: {
            RefreshTimetableEvents() {
                if (this.ActiveEnrolments.length > 0) {
                    this.LoadTimetableEventsByCourseCodes(this.ActiveEnrolments.map(e => e.CourseCode));
                }
            },
            OpenCourseTimetable(courseCode) {
                this.$router.push({ path: `/course/${courseCode}/timetable` });
            }
        },
        watch: {
            enrolments() {
                this.RefreshTimetableEvents();
            }
        }
    }
</script>
